var STATIC_TEXTS={
  "hair_wash_prefix":"You wash your hair ",
  "hair_status_postfix":" hair",
  "scalp_visible":"You have visible areas of scalp",
  "scalp_not_visible":"No Visible Areas Of Scalp"
};
var TESTIMONIALS={
  "":[""],
  "HORMONIAL":["I have thyroid issues and have struggled with hair loss for ten years. After I had my son, my postpartum hair loss was worse!!! I started using Reviv3 Procare 30-day kit regularly for a few months and was so happy to see the bald spots start filling in again!! I love this product. Thank you!","Rose M."],
  "MEDICAL":[" My hair has been thinning due to medication. I was desperate for something. I found this online and gave it a shot. It’s only been 3 washes, but my hair immediately felt and appeared to be thicker. I noticed way less fallout when combing my hair.","Linda M."],
  "PREGNACY":["After I had my son my hair started to fall out so drastically. I was balding at my temples and my hair thinned out completely. I used the 3 part system and my hair finally stopped falling out! I highly recommend this product. I’ve read that I should use it daily but I got these results just using 2-3 times a week!","Julie L."],
  "MENOPAUSE":["I love how Reviv3 products work on my hair. I noticed a huge decrease in hair loss and my hair has never felt this healthy before.","Brenda K."],
  "STRESS":["I used to see clumps of hair on my pillow and sink. Thanks to Reviv3 my hair has never been healthier and I don’t see more than a few hairs in my sink or shower! This is the best hair product I’ve tried and I would highly recommend it to everyone.","Lisa R."],
  "GENETICS":["Thinning hair doesn’t have to mean fewer options... For those who prefer a natural alternative, hand them Reviv3 Procare.","Modern Salon Magazine"]
}

var PRODUCT_POINTS={
  "revive-3-part-system":{
    "IMG":"https://cdn.shopify.com/s/files/1/0288/1381/9964/files/Artboard_8.png?v=1646936098",
    "POINTS":[
      {
        "answer":"haircondition::not_treated",
        "point":"Proprietary Blend of Naturally Derived Peptide & Vitamin Complexes, Hydrolized Rice Protein, Red Clover Flower Extract, Wasabi Root Ferment Extract, Caffeine, Biotin"
      },
      {
        "answer":"haircondition::color_treated",
        "point":"Prevents the formation of DHT and hair follicle clogging, increases your circulation and follicle stem cell health and shields your hair from UV rays and prevent color fading."
      },
      {
        "answer":"haircondition::chemically_treated",
        "point":"This protects against hair thinning, damage, and hair loss, safeguards your hair shafts and follicles"
      },
      {
        "answer":"hairtexture::thick",
        "point":"from environmental and chemical harm, and results in thicker, stronger, and healthier hair growth"
      },
      {
        "answer":"hairtexture::thin",
        "point":"Protects against hair thinning, damage, and hair loss, safeguards your hair shafts and follicles"
      },
      {
        "answer":"hairtexture::wavey_curly",
        "point":"A blend of 16 naturally derived extracts, keratin amino acids and plant proteins provides the optimum levels of nutrients to repair follicle  damage and maintain hair health for thicker, stronger hair growth."
      },
      {
        "answer":"hairwash::2_4x_week",
        "point":"Clinical studies showed 300% increase in hair strength"
      },
      {
        "answer":"hairwash::daily",
        "point":"Clinical studies showed 75% reduction in broken hair fibers"
      },
      {
        "answer":"hairwash::weekly",
        "point":"Clinical studies showed 100% of participants experienced improvements in scalp health"
      }
    ]
  },
  "boost":{
    "IMG":"https://cdn.shopify.com/s/files/1/0288/1381/9964/files/Artboard_6_8c38e2d1-659c-4cf9-8f6c-3210914a6ff1.png?v=1644531419",
    "POINTS":[
      {
        "answer":"scalpvisible::yes",
        "point":" Used twice daily, boost provides low-density density areas with a Tri-peptide dermal respiratory complex designed to increase cellular turnover and return scalp skin to a more youthful state."
      }
    ]
  },
  "mend-deep-hair-repair-mask":{
    "IMG":"https://cdn.shopify.com/s/files/1/0288/1381/9964/files/MEND_PDP_1_2_800x.png?v=1668100061",
    "POINTS":[
      {
        "answer":"hariconsider::dry",
        "point":"Protein-rich and intensely hydrating, this weightless hair masque treatment deeply penetrates your hair follicles and strands to strengthen, repair, and prevent damage, control frizz, and revive your hair’s natural elasticity."
      }
    ]
  }
}